import Dashboard from './Dashboard'

const DashboardRouter = {
  path: '/dashboard/*',
  component: Dashboard
}

export default DashboardRouter
